// import Skeleton from "react-loading-skeleton";
import Markdown from "react-markdown";
import { useTimer } from "../../../hooks/useTimer";

const Sticker = (props: any) => {
  // `cta` is optional: the /botb-pass hero puts its button outside the card,
  // the /prizes/lifestyle widget puts it inside.
  const { subscriptionData, subscriptionDataLoading, cta } = props;
  const shouldUseOfferTitle =
    subscriptionData?.offer?.offerTitle !== undefined &&
    subscriptionData?.offer?.offerTitle !== "" &&
    subscriptionData?.offer?.expireTime !== 0;
  const isCounterActive = typeof subscriptionData?.offer?.expireTime === "number";
  const { days, hours, minutes, seconds, milliseconds } = useTimer(
    "upsell-subscription-modal",
    (subscriptionData?.offer?.expireTime || 0) * 1000,
    undefined,
    "millisecond"
  );
  const milisecondsT = Math.floor(milliseconds / 10)
    .toString()
    .padStart(2, "0");

  return (
    <>
      {subscriptionDataLoading ? (
        ""
      ) : (
        <>
          {subscriptionData.offer ? (
            <div className={`relative mt-[15px] lg:mt-5 min-w-[260px] lg:min-w-[340px]`}>
              {shouldUseOfferTitle && (
                <div
                  className={
                    "absolute z-[1] -top-[15px] lg:-top-5 gap-1 shrink-0 flex min-w-[122px] h-[36px] lg:h-[45px] justify-center items-start [background:linear-gradient(93deg,#FFEB60_1.6%,#C1B142_134.06%)] px-2.5 py-0.5 lg:pt-[3px] lg:pb-1 rounded-[10px] lg:rounded-[14px]"
                  }>
                  <span
                    className={
                      "text-black [text-shadow:0_0_2.596px_rgba(255,255,255,0.20)] font-jost text-[10px] italic font-semibold leading-[11px] whitespace-nowrap lg:text-xs lg:leading-3.5"
                    }>
                    {subscriptionData.offer.offerTitle}
                  </span>
                </div>
              )}

              {isCounterActive && (
                <div
                  className={
                    "absolute z-[1] -top-[15px] lg:-top-5 gap-1 shrink-0 flex min-w-[122px] h-[36px] lg:h-[45px] justify-center items-start [background:linear-gradient(93deg,#FFEB60_1.6%,#C1B142_134.06%)] px-2.5 py-0.5 lg:pt-[3px] lg:pb-1 rounded-[10px] lg:rounded-[14px]"
                  }>
                  <span
                    className={
                      "text-black [text-shadow:0_0_2.596px_rgba(255,255,255,0.20)] font-jost text-[10px] font-semibold leading-[11px] whitespace-nowrap lg:text-xs lg:leading-3.5"
                    }>
                    Ends in <span className={"min-w-3.5 inline-flex text-right"}>{hours}</span>h :{" "}
                    <span className={"min-w-3.5 inline-flex justify-end"}>{minutes}</span>m :{" "}
                    <span className={"min-w-3.5 inline-flex text-right"}>{seconds}</span>
                    <span className={"min-w-3.5 inline-flex text-[8px] lg:text-[9px]"}>{milisecondsT}</span>
                  </span>
                </div>
              )}

              <div className={"relative z-[2] bg-end-date-badge rounded-[10px] lg:rounded-[14px]"}>
                <div
                  className={
                    "[&>*]:tracking-normal text-center text-white font-jost text-[11px] font-medium leading-none px-[7px] py-1 lg:pt-1.5 lg:pb-[5px] whitespace-nowrap lg:text-sm lg:leading-3.5"
                  }>
                  <Markdown
                    components={{
                      strong: props => (
                        <strong className="font-bold" {...props}>
                          {props.children}
                        </strong>
                      ),
                    }}>
                    {subscriptionData.offer.headline}
                  </Markdown>
                </div>
                <div
                  className={`bg-white relative px-[10px] pt-1.5 font-jost rounded-[10px] lg:rounded-[14px] lg:px-3.5 lg:pt-[7px] ${
                    cta ? "flex flex-col items-center gap-3 lg:gap-4 pb-3 lg:pb-4" : "pb-1.5 lg:pb-[7px]"
                  }`}>
                  <div className={"flex items-center w-full gap-2"}>
                    <div>
                      <img
                        src={subscriptionData.offer.offerImage}
                        alt={"Claim"}
                        width={40}
                        height={40}
                        className={"size-10 rounded-lg lg:size-[54px]"}
                      />
                    </div>
                    <div className={"flex-1 min-w-0"}>
                      <div
                        className={
                          "text-[11px] font-normal leading-[13px] text-secondary lg:text-sm lg:leading-[17px]"
                        }>
                        {subscriptionData.offer.bonus}
                      </div>
                      <div className={"text-[13px] font-bold leading-[17px] text-dark-1 lg:text-lg lg:leading-5.5"}>
                        {subscriptionData.offer.description}
                      </div>
                    </div>
                  </div>
                  {cta}
                </div>
              </div>
            </div>
          ) : null}
        </>
      )}
    </>
  );
};

export default Sticker;
